import { render, staticRenderFns } from "./Spot.vue?vue&type=template&id=b48f37d6&"
import script from "./Spot.vue?vue&type=script&lang=js&"
export * from "./Spot.vue?vue&type=script&lang=js&"
import style0 from "./Spot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/nakao_koichi/Project/Goshuin/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VImg,VLayout,VList,VListTile,VListTileContent,VListTileSubTitle,VListTileTitle})
